import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import VehicleCategoryBasicInfoComponent from './vehicle-category-basic-info.component';

export const VehicleCategoryComponent = ({ handleBasicFormChange, selectedVehicleCategory, transportAgents, transporters, back, handleFormSubmit }: any) => {


  const tabItems = [
    {
      id: 1,
      title: 'vehicle Category Information',
      component: <VehicleCategoryBasicInfoComponent
        handleBasicFormChange={handleBasicFormChange}
        selectedVehicleCategory={selectedVehicleCategory}
      />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />


      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default VehicleCategoryComponent;
